import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { FieldInterventionFormsService } from '@connect-services/src/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class FieldInterventionFormBloc extends Bloc<
    FieldInterventionFormsService['fieldInterventionFormControllerGetOne']
> {
    public constructor(service: FieldInterventionFormsService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.fieldInterventionFormControllerGetOne.bind(service), {
            debug: debug ?? false,
        });
    }
}
